import { Autocomplete, Button, DialogActions, DialogContent, Divider, Grid, TextField } from "@mui/material";
import DP_Dropdown from "./DP_Dropdown";
import { useEffect, useState } from "react";
import { fetchResources } from "../../actions/Users/authenticate";
import { FreeSoloCreateOption } from "../../UserScreen/InventoryPage/InventorySettings/UserScreens/TransferTab/CreateSiteDropdown";
import { createVessel, attachDeviceToSiteData, getInventoryWarehouseTableData } from "../../actions/Users/authenticateInventory";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { CONFIRM_DIALOG_TITLE } from "../../config";
import { getDataFromLocalStorage, hasLicensePermission } from "../../utils/util";
import { CREATE_AND_ASSIGN_INVENTORY, FETCH_OU_RESOURCES, GET_ATTACH_DEVICE_TO_SITE } from "../../actions/types";
import _ from "lodash";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const AssignSite = (props) => {
    const { row, setOpen, fetchResources, fetchResourcesData, createVessel, createVesselData, attachDeviceToSiteData, setAttachDeviceToSiteLoading, getAttachDeviceToSite, selectedOu } = props;
    const [vessels, setVessels] = useState<any>();
    const [checkInputValue, setCheckInputValue] = useState(false);
    const [changedOuInfo, setChangedOuInfo] = useState<any>({ name: row['dpname'], id: row['dpId'] });
    const [siteValue, setSiteValue] = useState<any>({});
    const [value, setValue] = useState<any>(null);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
        onConfirm: () => { },
    });
    const [contactName, setContactName] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const dispatch = useDispatch();
    const selectedLicense = row?.['tierAlias'];
    const selectedTerm = row?.['termDisplay'];

    useEffect(() => {
        const _loggedInUser: any = getDataFromLocalStorage("loggedInUser");
        if (_loggedInUser) {
            const loggedInUser = JSON.parse(_loggedInUser);
            if (loggedInUser?.data?.user) {
                setContactName(`${loggedInUser?.data?.user?.name?.givenName} ${loggedInUser?.data?.user?.name?.familyName}`);
                setContactEmail(`${loggedInUser?.data?.user.userName}`)
            }
        }
    }, []);

    useEffect(() => {
        if (!_.isEmpty(fetchResourcesData)) {
            let resourceRecords = fetchResourcesData?.locations;
            if (resourceRecords && Array.isArray(resourceRecords)) {
                let resourceSort = resourceRecords.sort((a, b) => a.name - b.name);
                const list = resourceSort?.map((vs) => {
                    return { label: vs.name, id: vs.id }
                })
                setVessels(list);
            } else {
                setVessels([]);
            }
            dispatch({ type: FETCH_OU_RESOURCES, payload: {} })
        }
    }, [fetchResourcesData]);

    useEffect(() => {
        if (!_.isEmpty(createVesselData)) {
            if (createVesselData.hasOwnProperty("status") && createVesselData.status == 1) {
                setSiteValue({ label: createVesselData?.data?.name, id: createVesselData?.data?.k4Id })
            }
            dispatch({ type: CREATE_AND_ASSIGN_INVENTORY, payload: {} })
        }
    }, [createVesselData]);

    const handleOu = (ou: any) => {
        setChangedOuInfo(ou);
        fetchResources(ou.name, 0, 500, '', '');
        setSiteValue({});
        setValue(null);
    }

    const handleCreateAndAssignInventory = (siteValue) => {
        if (siteValue) {
            let payload = {
                "vesselName": siteValue,
                "contactName": contactName,
                "contactEmail": contactEmail,
                "k4DpId": changedOuInfo?.id,
                "source": "SPORT"
            }
            createVessel(contactEmail, payload)
        }
    }

    useEffect(() => {
        if (!_.isEmpty(getAttachDeviceToSite)) {
            const res = getAttachDeviceToSite;
            if (res?.message && (res?.error_code == 20019 || res?.error_code == 20018)) {
                setConfirmDialog({
                    isOpen: true,
                    title: CONFIRM_DIALOG_TITLE,
                    subTitle: res?.message,
                    onConfirm: () => {
                        const payload = {
                            did: row?.deviceId,
                            k4Id: siteValue.id,
                            name: siteValue.label,
                            isValidated: true
                        }
                        attachDeviceToSiteData(payload);
                    },
                })
            } else if (res.hasOwnProperty("status") && res.status == 1) {
                handleClose();
                getInventoryWarehouseTableData(selectedOu?.id, '', 1, 15, 'shipmentDate', 'desc');
            }
        }
    }, [getAttachDeviceToSite]);

    const handleClose = () => {
        setSiteValue({});
        setValue(null);
        setOpen(false);
        dispatch({ type: GET_ATTACH_DEVICE_TO_SITE, payload: {} })
    }

    const handleConfirmClick = () => {
        confirmDialog.onConfirm();
    }

    return (
        hasLicensePermission('TransferLicenseRW') ? <div className="Form assignInventory-container warehouseOrgDropdown">
            {confirmDialog.isOpen && <div className="custom_confirm_dialog_sub_title edit-actions-subTitle">
                {confirmDialog.subTitle}
                <div className="edit-actions-confirm-btns">
                    <Divider className="confirm-dialogue-new-divider" />
                    <div className="confirm-dialogue-new-btns">
                        <Button className="confirm-dialogue-cancel" onClick={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}> Cancel </Button>
                        {
                            !setAttachDeviceToSiteLoading ? (
                                <Button className="confirm-dialogue-proceed" onClick={() => handleConfirmClick()}>
                                    Proceed
                                </Button>
                            ) : (
                                <Button className="confirm-dialogue-proceed-notAllow">
                                    Proceed
                                </Button>
                            )
                        }
                    </div>
                </div>
            </div>}
            {!confirmDialog.isOpen && <>
                <DialogContent>
                    <Grid container className="deploy-inventory-content register-inventory-content">
                        <Grid className="selectedDeviceDetails">
                            <Grid>Select/Create a site from below to assign <span className="selectedProductType">{`(${row?.deviceId})`}</span></Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} className="config-select-site-deploy">
                            <span id="content-left-text">Select Organization</span>
                            <DP_Dropdown isSmall={true} isReports={false} setOu={handleOu} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} className="select-site-check" >
                            <div>
                                <span id="content-left-text">Create / Search Site</span>
                                <FreeSoloCreateOption
                                    vesselNames={vessels?.length > 0 ? vessels : []}
                                    check={setCheckInputValue}
                                    setSiteValue={setSiteValue}
                                    value={value}
                                    setValue={setValue}
                                    handleCreateAndAssignInventory={handleCreateAndAssignInventory}
                                />
                            </div>
                            <span className={checkInputValue ? "input-text-char-check" : ''}>{checkInputValue ? `Character " ' " is Not allowed` : ''}</span>
                        </Grid>
                        {
                            <Grid item xs={12} sm={12} md={12} lg={12} className="select-site-check" >
                                <div className="margintop-10px">
                                    <span id="content-left-text">Select License</span>
                                    <Autocomplete
                                        style={{ opacity: 0.5 }}
                                        freeSolo
                                        disableClearable
                                        forcePopupIcon={true}
                                        popupIcon={<KeyboardArrowDownIcon />}
                                        ListboxProps={{ className: 'warehouse-apply-config-props' }}
                                        className="audit-filter-inputs-usage config-textField"
                                        selectOnFocus
                                        clearOnBlur
                                        handleHomeEndKeys
                                        size='small'
                                        value={selectedLicense}
                                        options={[]}
                                        onChange={() => {  }}
                                        renderInput={({ inputProps, ...params }) => (
                                            <TextField {...params} placeholder="select"
                                                inputProps={{ ...inputProps, readOnly: true }}
                                            />
                                        )}
                                        readOnly
                                    />
                                </div>
                            </Grid>
                        }
                        {
                            <Grid item xs={12} sm={12} md={12} lg={12} className="select-site-check" >
                                <div className="margintop-10px">
                                    <span id="content-left-text">Select Term</span>
                                    <Autocomplete
                                        style={{ opacity: 0.5 }}
                                        freeSolo
                                        disableClearable
                                        forcePopupIcon={true}
                                        popupIcon={<KeyboardArrowDownIcon />}
                                        ListboxProps={{ className: 'warehouse-apply-config-props' }}
                                        className="audit-filter-inputs-usage config-textField"
                                        selectOnFocus
                                        clearOnBlur
                                        handleHomeEndKeys
                                        size='small'
                                        options={[]}
                                        value={selectedTerm}
                                        onChange={() => { }}
                                        renderInput={({ inputProps, ...params }) => (
                                            <TextField {...params} placeholder="select"
                                                inputProps={{ ...inputProps, readOnly: true }}
                                            />
                                        )}
                                        readOnly
                                    />
                                </div>
                            </Grid>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <div className="register-edit-actions-confirm-btns">
                        <Divider className="confirm-dialogue-new-divider" />
                        <div className="confirm-dialogue-new-btns">
                            <Button className="confirm-dialogue-cancel" onClick={handleClose}> Cancel </Button>
                            <Button className={siteValue?.label ? 'confirm-dialogue-proceed' : 'confirm-dialogue-proceed-notAllow'}
                                disabled={!siteValue?.label}
                                onClick={() => {
                                    setConfirmDialog({
                                        isOpen: true,
                                        title: CONFIRM_DIALOG_TITLE,
                                        subTitle: `Confirm to attach device (${row?.deviceId}) on site ${siteValue.label} ?`,
                                        onConfirm: () => {
                                            const payload = {
                                                did: row?.deviceId,
                                                k4Id: siteValue?.id,
                                                name: siteValue?.label,
                                                isValidated: false
                                            }
                                            attachDeviceToSiteData(payload);
                                        },
                                    })
                                }}
                            >Register</Button>
                        </div>
                    </div>
                </DialogActions>
            </>}
        </div> : <div>Registration is restricted for you.</div>
    );
};

const mapStateToProps = (state) => ({
    fetchResourcesData: state.authReducer.fetchResources,
    createVesselData: state.authReducer.createVessel,
    getAttachDeviceToSite: state.authReducer.getAttachDeviceToSite,
    setAttachDeviceToSiteLoading: state.authReducer.setAttachDeviceToSiteLoading,
    selectedOu: state.authReducer.selectedOu,
});

export default withRouter(
    connect(mapStateToProps, { fetchResources, createVessel, attachDeviceToSiteData })(AssignSite)
);